import { notification } from "antd";
import { sendBirdClient } from "./sendbird";
// import * as ChatActions from '../../actions/chat';
import * as MessageActions from '../../actions/messages';
import { channelSchema, messageSchema } from "./sendbirdSchema";
// import { sendPingMessage, sendTopicChangeMessage } from "./sendSendbirdMessage";
import { store, history } from '../../store';
// import MessageReceiptState from "./messageReceiptState";
// import ChatType from '../../constants/chatType';
import _ from 'lodash';
import { v4 as uuid } from 'uuid';
import Queue from "./queue";

const { dispatch } = store;

let channelListQuery;

export async function connectUser(user, dispatch) {
    await sendBirdClient.connect(
        user.mobileNumber,
        (sendbirdUser, error) => {
          if (error) {
            console.log(error);
          } else {
            getChannels(sendbirdUser, dispatch);
          }
        }
      );

      
    // await sendBirdClient.connect(
    //     user.mobileNumber,
    //     (sendbirdUser, error) => {
    //         if (error) {
    //             console.log(error)
    //             notification['error']({
    //                 message: 'Error',
    //                 description: 'Could not connect with Sendbird. Please refresh again.',
    //             });
    //         } else {
    //             console.log(sendbirdUser)
    //             if (sendbirdUser.nickname === "" && user.firstName) {
    //                 let nickname = user.firstName + " " + user.lastName;
    //                 sendBirdClient.updateCurrentUserInfo(decodeURIComponent(nickname), null, (sendbirdUser, error) => {
    //                     console.log(sendbirdUser)
    //                     fetchMoreChats(dispatch)
    //                 });
    //             }
    //         }
    //     }
    // );
    // return;
}

export async function getChannels(sendbirdUser, dispatch) {
  channelListQuery = sendBirdClient.GroupChannel.createMyGroupChannelListQuery();
  channelListQuery.limit = 14;
  channelListQuery.includeEmpty = true;
  channelListQuery.order = 'latest_last_message';

  //if (channelListQuery.hasNext) {
  await channelListQuery.next(async function (channelList, error) {

    //dispatch(MessageActions.setChatList(channelList));
    // dispatch()
    if (error) {
      console.log(error)
      return;
    }
    attachChatList(channelList, null)
  });
  //  }
}
  export async function listMessage( url) {
    try {
      sendBirdClient.GroupChannel.getChannel(url, async function (groupChannel, error) {
        if (error) {
          return false
        }
  
        let messageListQuery = await groupChannel.createPreviousMessageListQuery();
        messageListQuery.limit = 20;
        messageListQuery.reverse = true;
        messageListQuery.includeMetaArray = true;
        messageListQuery.includeReaction = true;
  
        let messages = await messageListQuery.load(async function (messageList, error) {
          if (error) {
  
            notification['error']({
              message: 'error',
              description: 'An error occured. Please try again later.',
            });
            return;
          }
          dispatch(MessageActions.setMessageList(messageList));
          // return messageList.length;
          //localStorage.setItem('totalMessages', messageList.length)
          return true
  
        });
      });
    } catch (e) {
      console.log(e)
    }
    return false
  }

  


export async function disconnectUser(user) {
    await sendBirdClient.disconnect((response, error) => {
        if (error) {
            console.log(error);
        }
    });
    return;
}

// export async function getChannelList(currentChannelId, dispatch1) {
//     channelListQuery = sendBirdClient.GroupChannel.createMyGroupChannelListQuery();
//     channelListQuery.limit = 14;
//     channelListQuery.includeEmpty = true;
//     channelListQuery.order = 'latest_last_message';


//     if (channelListQuery.hasNext) {
//         await channelListQuery.next(async function (channelList, error) {
//             if (error) {
//                 console.log(error)
//                 return;
//             }
//             console.log(channelList)
//             dispatch(MessageActions.setChatList(channelList));
//            // attachChatList(channelList, currentChannelId);
//         });
//     }
// }


// export async function getChannelListComplete(currentChannelId, dispatch) {
// 	channelListQuery = sendBirdClient.GroupChannel.createMyGroupChannelListQuery();
// 	channelListQuery.limit = 50;
// 	channelListQuery.includeEmpty = true;
// 	channelListQuery.order = 'latest_last_message';


// 	if (channelListQuery.hasNext) {
// 			await channelListQuery.next(async function (channelList, error) {
// 					if (error) {
// 							return;
// 					}
// 					attachChatList(channelList, currentChannelId);
// 			});
// 	}
// }

export function fetchMoreChats(dispatch) {
	return Queue.enqueue(()=>{
		return new Promise((resolve, reject) => {
				channelListQuery.next(async function (channelList, error) {
						if (error) {
								// if(!error?.toString()?.toLowerCase()?.includes('query in progress'))
								// 		chatReload(dispatch); 
								reject(error) 
								return;
						}
						attachChatList(channelList, null);
						resolve(channelList);
				});
		});
	});
}

// export function fetchChatByChannelId(channelId, callback) {

//     sendBirdClient.GroupChannel.getChannel(channelId, async function (channel, error) {
//         if (error) {
//           chatReload(dispatch)  
//           return error;
//         }
//         if (callback) {
//             callback(channel.url);
//         }
//         attachChatList([channel], channel.url);
//         channel.markAsRead();
//         channel.refresh(function (response, error) {
//             if (error) { }
//             channel.markAsRead()
//         });
//     });
// }
// // second func for button click
// export function fetchChannelByChatId(channelId, callback, onError) {

//     sendBirdClient.GroupChannel.getChannel(channelId, async function (channel, error) {
//         if (error) {
//             onError(error)  
//           return 
//         }
//         if (callback) {
//             callback(channel, error);
//         }
//         // attachChatList([channel], channel.url);
//         // channel.markAsRead();
//         // channel.refresh(function (response, error) {
//         //     if (error) { }
//         //     channel.markAsRead()
//         // });
//     });
// }

// export async function getReadReceipt(sendBirdChannel, currentUserId, message) {
//     let recipeintStatus = {};

//     let readMembers = await sendBirdChannel?.getReadMembers(message || sendBirdChannel.lastMessage);

//     if (readMembers?.length > 0) {
//         readMembers.forEach((identity) => {

//             recipeintStatus[identity.userId] = MessageReceiptState.READ;
//         });
//         currentUserId && (recipeintStatus[currentUserId] = MessageReceiptState.READ);
//     }

//     return recipeintStatus;
// }

export async function attachChatList(channelList, currentChannelId = null) {
    let channelListObject = {};
    let fetchChannelData = true;
    let chatList = []
    await Promise.all(channelList.map(async (channel) => {
        let messageSource = channel.createPreviousMessageListQuery();
        messageSource.limit = 20;
        messageSource.reverse = true;
        messageSource.includeMetaArray = true;
        messageSource.includeReaction = true;
        let structuredChannel = await channelSchema(channel, messageSource);
        // console.log(structuredChannel)
        // if (currentChannelId && structuredChannel.id === currentChannelId) {
        //     fetchChannelData = false;
        //     fetchMessageList(structuredChannel, dispatch);
        // }
        chatList.push(structuredChannel)
        // channelListObject[structuredChannel.id] = structuredChannel;
        // if (channel.lastMessage) {
        //     let lastMessage = await messageSchema(channel.lastMessage);

        //     if (lastMessage == null) return
        //     const recipeintStatus = await getReadReceipt(channel)
        //     let messageObject = [];
        //     messageObject.push({
        //         ...lastMessage,
        //         recipeintStatus
        //     });
        //     dispatch(MessageActions.appendMessageList(messageObject, structuredChannel.id));
        // }
    }));
    dispatch(MessageActions.setChatList(chatList));
    // if (currentChannelId && fetchChannelData) {
    //     fetchChatByChannelId(currentChannelId);
    // }

    //dispatch(ChatActions.appendConversation(channelListObject));
}


// export async function fetchMessageList(channel, dispatch, callback) {
//     console.log(channel)
//     channel.messageSource.load(async function (messageList, error) {
//         if (error) {

//             // fetchMessageList on error fetch channel list
//             //chatReload(dispatch)
//             return;
//         }
//         console.log(messageList)
//         let messageObject = [];
//         // await Promise.all(messageList.map(async (message) => {
//         //     let structuredMessage = await messageSchema(message);

//         //     if (structuredMessage == null) return

//         //     let recipeintStatus = await getReadReceipt(channel.rawData, null, message);
//         //     messageObject.push({
//         //         ...structuredMessage,
//         //         recipeintStatus
//         //     });
//         // }));
//         // console.log(messageObject)
//         // dispatch(MessageActions.appendMessageList(messageObject, channel.id));
//         // if (callback) callback(messageObject)

//     });
// }

export async function fetchMoreMesssages(channel, dispatch) {

    return Queue.enqueue(() => {
        const storeData = store.getState();
        const { messages } = storeData;
        let messageObject = [];
        let messageList = []
        let messageObjectAll = Object.values(messages?.messageList || []);
        if (!channel.messageSource) return Promise.resolve();
        return new Promise((resolve) => {
            channel.messageSource.load(async function (messageList, error) {
                if (error) {
                    // if (!error?.toString()?.toLowerCase()?.includes('query in progress'))
                    //     chatReload(dispatch);
                    console.log('error')
                    return;
                }

                await Promise.all(messageList.map(async (message) => {
                    let structuredMessage = await messageSchema(message);
                    if (structuredMessage == null) return
                    //let recipeintStatus = await getReadReceipt(channel.rawData, null, message);
                    messageObject.push({
                        ...structuredMessage
                    });
                }));
                messageList.push(messageObject)
                 dispatch(MessageActions.appendMessageList(messageObject, channel.id));
                // messageObjectAll = [...messageObjectAll, ...messageObject];
                // messageObjectAll = messageObjectAll.filter((item, i, array) => {
                //     return array.findIndex(mess => mess.internalMessageId == item.internalMessageId) == i
                // })
                 resolve(messageObjectAll);
            })
        });
    });
}

// export async function fetchChatMesssagesByChat(channel, dispatch) {
//     let messageObject = [];
//     channel.messageSource.load(async function (messageList, error) {
//         if (error) {
           
//           return null;
//         }

//         await Promise.all(messageList.map(async (message) => {
//             let structuredMessage = await messageSchema(message);
//             if (structuredMessage == null) return
//             let recipeintStatus = await getReadReceipt(channel.rawData, null, message);
//             messageObject.push({
//                 ...structuredMessage,
//                 recipeintStatus
//             });
//         }));
//         return messageObject
//     });
// }


// export async function createConversation(data, callback, historyProp, isDirect) {
//     const { participants, metadata, isDistinct, isEphemeral, isPublic, name } = data;

//     let params = new sendBirdClient.GroupChannelParams();

//     params.isPublic = isPublic || false;
//     params.isEphemeral = isEphemeral || false;
//     params.isDistinct = isDistinct; //distinct false for wokflows and care team chat => distinct true for others
//     params.addUserIds(participants);
//     params.customType = data.customType;
//     params.data = JSON.stringify(metadata);
//     params.operatorUserIds = [data.currentUser];   // or .operators(Array<User>)
//     params.name = name;
// 		if(data.channelUrl) params.channelUrl = data.channelUrl;


//     const channel = await sendBirdClient.GroupChannel.createChannel(params, async function (groupChannel, error) {
//         if (error) {
//              console.log(error);
// 						 if(error.toString()?.includes('violates unique constraint')){
// 								// already exists
// 								if (callback) {
// 									callback({url: params.channelUrl});
// 							}
// 							(historyProp || history).push("/chats/" + params.channelUrl);
// 						 }
// 						 return;
//         }

// 				if (!isDirect) await sendPingMessage({
//             rawData: groupChannel,
//             metadata
//         });
//         await groupChannel.updateMetaData(metadata, true, function (response, error) {
//             if (error) {
//                 // console.log(error);
//             }
//         });

//         if (callback) {
//             callback(groupChannel);
//         }
//         (historyProp || history).push("/chats/" + groupChannel.url);

//         return groupChannel;
//     });

//     return channel;
// }


// export async function deleteChannel(channelId) {
//     let channel = await sendBirdClient.GroupChannel.getChannel(channelId)
//     channel.delete()
// }

// export async function changeChannelName(newTopic, channel) {


//     let params = new sendBirdClient.GroupChannelParams();

//     let metadata = JSON.parse(channel.rawData.data);
//     Object.assign(metadata, {
//         topic: newTopic
//     });
//     params.data = JSON.stringify(metadata);

//     params.name = newTopic;
//     await channel.rawData.updateChannel(params, function (groupChannel, error) {
//         if (error) {
//             // console.log("Error in updating channel: ", error)
//             console.log('error')
//             console.log(error)

//             return (error);
//         }
        
//         sendTopicChangeMessage(newTopic, channel)
//         return;
//     });

//     await channel.rawData.updateMetaData({
//         topic: newTopic
//     }, true, function (response, error) {
//         if (error) {
//             // console.log("Error in updating channel: ". error)
//             return (error);
//         }
//         return;
//     });

// }


// export async function updateMetaData(formstatus,channel) {

//     //formstatus: JSON.stringify(formstatus)

//     let params = new sendBirdClient.GroupChannelParams();

//     let metadata = JSON.parse(channel.rawData.data);

//     metadata.formstatus = JSON.stringify(formstatus)

  
//     params.data = JSON.stringify(metadata);

//     await channel.rawData.updateChannel(params, function (groupChannel, error) {
//         if (error) {
//             // console.log("Error in updating channel: ", error)
//             return (error);
//         }

//         return;
//     });

//     await channel.rawData.updateMetaData({
//         ...metadata
//     }, true, function (response, error) {
//         if (error) {
//             // console.log("Error in updating channel: ". error)
//             return (error);
//         }
//         return;
//     });

// }

// export async function updateMetaDataCustom(newMetaData,channel) {

//     //formstatus: JSON.stringify(formstatus)

//     let params = new sendBirdClient.GroupChannelParams();

//     let metadata = JSON.parse(channel.rawData.data);

//     //metadata.formstatus = JSON.stringify(formstatus)

    
//     params.data = JSON.stringify(newMetaData);

//     await channel.rawData.updateChannel(params, function (groupChannel, error) {
//         if (error) {
//             // console.log("Error in updating channel: ", error)
//             return (error);
//         }

//         return;
//     });

//     await channel.rawData.updateMetaData({
//         ...metadata
//     }, true, function (response, error) {
//         if (error) {
//             // console.log("Error in updating channel: ". error)
//             return (error);
//         }
//         return;
//     });

// }

// export async function updateMetaTags(metatags, channel) {

//     let params = new sendBirdClient.GroupChannelParams();

//      params.data = JSON.stringify(metatags);

//     await channel.rawData.updateChannel(params, function (groupChannel, error) {
//         if (error) {
//             // console.log("Error in updating channel: ", error)
//             return (error);
//         }

//         return;
//     });

//     await channel.rawData.updateMetaData({
//         ...metatags
//     }, true, function (response, error) {
//         if (error) {
//             // console.log("Error in updating channel: ". error)

//             return (error);
//         }

//         return;
//     });

// }

// const chatReload = (dispatch) => {
//   getChannelList(undefined, dispatch);
//   if(window.location.pathname.includes('/chats') && (!window.location.pathname.endsWith('chats') || !window.location.pathname.endsWith('chats/'))){
//     history.push('/chats')
//   }
// }


// export const showChat = async (contact, props) => {
// 	let { setting, history: historyProp } = props
// 	let { currentUser } = setting
// 	let memberIds = _.union([contact.mobileNumber, currentUser.mobileNumber]);

// 	const metadata = {
// 		topic: contact.firstName + ' ' + contact.lastName,
// 		chatId: uuid(),
// 		type: ChatType.DIRECT,
// 		creatorId: currentUser.mobileNumber,
// 		creatorName: currentUser.nickname || (currentUser.firstName + ' ' + currentUser.lastName),
// 		chatApp: "web",
// 	}

// 	const data = {
// 		metadata,
// 		participants: memberIds,
// 		isDistinct: true,
// 		name: metadata.topic,
// 		currentUser: currentUser.mobileNumber,
// 		customType: metadata.type,
// 		memberIds: memberIds,
// 	}

// 	//create conversation if not already present
// 	const { chats } = props;
// 	let isChatPresent = false;


// 	if (!isChatPresent) await createConversation(data, undefined, historyProp, true);
// }
